exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-681ce09e]{max-height:200px}@media (max-width:575px){.btn[data-v-681ce09e]{display:block;width:100%}}", ""]);

// exports
